/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/15/20
Engine Hours component: called in irrigation_form
**********************************************************/
import { NumberInput } from '../../components/inputs';
import { calculateTotalFuelGallons } from '../irrigation_utils';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  engines: PropTypes.array,
  handleEngineHours: PropTypes.func
};

const EngineHours = ({ engines, handleEngineHours, edit }) => {
  return (
    <div>
      <div className="card z-depth-2">
        <div className="card-content">
          <span className="card-title blue-text"><u>Engine Hours</u></span>
          {
            engines.map((e) => (
              <div key={e.equipmentNo}>
                <NumberInput id={`engine${e.id}-hours`} name={`engine-${e.id}`} label={e.name} min={0} max={1000} _class={'irr-label'} 
                  onChange={() => handleEngineHours({
                    e: {
                      engineId: e.id,
                      hours: document.getElementById(`engine${e.id}-hours`).value,
                      totalFuelGal: calculateTotalFuelGallons({ hours: document.getElementById(`engine${e.id}-hours`).value, galPerHour: e.galPerHour })
                    },
                    edit
                  })}  
                />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}


EngineHours.propTypes = propTypes;
export default EngineHours;



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/irrigation_engine_hours.js